var React = require('react');

function Star (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0H42V42H0V0Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.992 13C16.576 13 13 16.584 13 21C13 25.416 16.576 29 20.992 29C25.416 29 29 25.416 29 21C29 16.584 25.416 13 20.992 13ZM24.384 25.8L21 23.76L17.616 25.8L18.512 21.952L15.528 19.368L19.464 19.032L21 15.4L22.536 19.024L26.472 19.36L23.488 21.944L24.384 25.8Z","fill":"#4C3371","key":1})]);
}

Star.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Star;

Star.default = Star;
